import { Flex, IconButton, ProfilePhoto, XCloseIcon } from "@minervaproject/fds";
import ReactModal from "react-modal";

import { ProcessedChatMessage } from "components/sidebar/chat";
import { useCapability } from "hooks/capabilities";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { useUsersProfileProperties } from "hooks/use_user_properties";
import { setFeaturedInModal } from "shared/reducers/classroom";
import { CapabilityType } from "shared/types";
import { classroomSelectors } from "store/index";
import { computeInitials, longDisplayName, profilePhotoUrl } from "utils/user";

function FeaturedMessageModal() {
  ReactModal.setAppElement("#root");
  const dispatch = useAppDispatch();
  const canControlClassroom = useCapability(CapabilityType.CAN_CONTROL_CLASSROOM);
  const { featured_in_modal } = useAppSelector(classroomSelectors.selectStage());
  const chat = useAppSelector(classroomSelectors.selectChatById(featured_in_modal));
  const users = useUsersProfileProperties();
  const user = users[chat?.user_id || ""] || null;
  const userCanMentionEveryoneInChat = useCapability(CapabilityType.CAN_MENTION_EVERYONE_IN_CHAT, {
    userId: chat?.user_id,
  });

  if (!featured_in_modal || !chat || !user) return null;

  const onClose = () => {
    dispatch(setFeaturedInModal({}));
  };

  const containerId = "#stage-container";
  return (
    <ReactModal
      className="bg-white shadow-level-4 py5 px4 absolute-center outline-none"
      overlayClassName="default-modal-overlay"
      parentSelector={() => document.querySelector(containerId)!}
      onRequestClose={onClose}
      shouldCloseOnEsc={canControlClassroom}
      shouldCloseOnOverlayClick={canControlClassroom}
      isOpen
      shouldFocusAfterRender={false}
    >
      {" "}
      {canControlClassroom && (
        <div style={{ position: "absolute", top: 16, right: 16 }}>
          <IconButton
            onClick={onClose}
            name="modal.close"
            aria-label="Close modal"
            data-testid="featured-message-modal-close-button"
          >
            <XCloseIcon size="lg" color="blackTint70" />
          </IconButton>
        </div>
      )}
      <Flex
        auto
        style={{ width: "400px", maxHeight: "calc(100vh - 300px)" }}
        data-testid="featured-message-modal"
      >
        <ProfilePhoto
          className="mr3"
          size="lg"
          initials={computeInitials(user)}
          src={profilePhotoUrl(user)}
        />

        <div className="flex flex-column pr5">
          <div
            className="name body-s bold text-black-tint-40 mb1"
            data-testid="featured-message-modal-user"
          >
            {longDisplayName(user)}
          </div>
          <div
            className="message-text body text-black-tint-20 vertical-scroll wrap-words pr4"
            data-testid="featured-message-modal-message"
          >
            <ProcessedChatMessage
              chat={chat}
              users={users}
              userCanMentionEveryoneInChat={userCanMentionEveryoneInChat}
            />
          </div>
        </div>
      </Flex>
    </ReactModal>
  );
}

export { FeaturedMessageModal };
